<template><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 14 14" width="14" height="14">
  <path style="fill:none;stroke:#686663;stroke-width:2px" d="M.7 12.7l12-12M.7.7l12 12" />
</svg>
</template>